import React from 'react';

export const Row = ({ children, paddingBottom }) => {
  return (
    <tr
      style={{
        paddingBottom: paddingBottom,
      }}
    >
      {children}
    </tr>
  );
};
